export type LocationDisplay =
  | { kind: "text"; text: string; linkUrl: string | null }
  | { kind: "link"; linkUrl: string; label: string }
  | null;

export function resolveEventLocationDisplay(
  eventLocation: string | null | undefined,
  eventLocationLink: string | null | undefined,
): LocationDisplay {
  if (eventLocation?.trim()) {
    return { kind: "text", text: eventLocation.trim(), linkUrl: eventLocationLink?.trim() || null };
  }
  if (eventLocationLink?.trim()) {
    return { kind: "link", linkUrl: eventLocationLink.trim(), label: "View on Map" };
  }
  return null;
}

export function resolveEventUrlDisplay(
  eventUrl: string | null | undefined,
  eventUrlText: string | null | undefined,
): { href: string; label: string } | null {
  if (!eventUrl?.trim()) return null;
  return { href: eventUrl.trim(), label: eventUrlText?.trim() || "Click here" };
}
